(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/pages/depositLimits/set-deposit-limits.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/pages/depositLimits/set-deposit-limits.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect,
  Fragment = _React.Fragment;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const Button = svs.ui.ReactButton;
const StepIndicatorBalls = svs.components.tb_ui.stepIndicatorBalls.StepIndicatorBalls;
const _svs$playerRegistrati = svs.playerRegistration.components,
  Footer = _svs$playerRegistrati.Footer,
  Header = _svs$playerRegistrati.Header,
  DesktopContentConstrain = _svs$playerRegistrati.DesktopContentConstrain,
  PageTitle = _svs$playerRegistrati.PageTitle,
  FadeInSlideWrapper = _svs$playerRegistrati.FadeInSlideWrapper;
const GridBase = svs.tb_ui_react.gridbase.GridBase;
const _svs$accountservicesR = svs.accountservicesReact.gameLimitDepositsForm,
  SetDepositLimitsFormDropdown = _svs$accountservicesR.SetDepositLimitsFormDropdown,
  SetDepositLimitsConfirm = _svs$accountservicesR.SetDepositLimitsConfirm,
  LimitCoverageInfo = _svs$accountservicesR.LimitCoverageInfo,
  LimitCoverageWarning = _svs$accountservicesR.LimitCoverageWarning,
  DepositLimitsFAQ = _svs$accountservicesR.DepositLimitsFAQ;
const helpers = svs.playerRegistration.helpers;
const routes = svs.playerRegistration.constants.routes;
const _svs$playerRegistrati2 = svs.playerRegistration.dialogs,
  showHandleDoItLaterDialog = _svs$playerRegistrati2.showHandleDoItLaterDialog,
  showLimitWarningDialog = _svs$playerRegistrati2.showLimitWarningDialog;
const service = svs.accountservicesReact.gameLimitDepositsForm.maxLimitsService;

const SetDepositLimits = () => {
  var _svs, _svs2;
  const extraData = ReactRedux.useSelector(state => state.playerregistrationreact);
  const amount = (extraData === null || extraData === void 0 ? void 0 : extraData.amount) || null;
  const product = (extraData === null || extraData === void 0 ? void 0 : extraData.product) || null;
  const preDefinedLimitsSupporternEnabled = helpers.getPreDefinedLimitsSupporternEnabled();
  const returnUrl = helpers.getReturnUrl();
  const isInRegisterFlow = helpers.getIsInRegisterFlow(extraData === null || extraData === void 0 ? void 0 : extraData.setLimits);
  const history = useHistory();
  const isUnderTwenty = ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.playerRegistration) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 ? void 0 : _svs.isUnderTwenty) || false;
  const isTwentyToTwentyFive = ((_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.playerRegistration) === null || _svs2 === void 0 || (_svs2 = _svs2.data) === null || _svs2 === void 0 ? void 0 : _svs2.isTwentyToTwentyFive) || false;
  const _useState = useState('form'),
    _useState2 = _slicedToArray(_useState, 2),
    step = _useState2[0],
    setStep = _useState2[1];
  const suggestedLimitsABTest = svs.components.targeting.isTargeted('COT_Insattningsgranser_FastaBelopp', 'B');
  const _useState3 = useState(suggestedLimitsABTest ? '500' : null),
    _useState4 = _slicedToArray(_useState3, 2),
    dayLimit = _useState4[0],
    setDayLimit = _useState4[1];
  const _useState5 = useState(suggestedLimitsABTest ? '500' : null),
    _useState6 = _slicedToArray(_useState5, 2),
    weekLimit = _useState6[0],
    setWeekLimit = _useState6[1];
  const _useState7 = useState(suggestedLimitsABTest ? '1000' : null),
    _useState8 = _slicedToArray(_useState7, 2),
    monthLimit = _useState8[0],
    setMonthLimit = _useState8[1];
  const _useState9 = useState(true),
    _useState0 = _slicedToArray(_useState9, 2),
    isPredefinedDayLimit = _useState0[0],
    setIsPredefinedDayLimit = _useState0[1];
  const _useState1 = useState(true),
    _useState10 = _slicedToArray(_useState1, 2),
    isPredefinedWeekLimit = _useState10[0],
    setIsPredefinedWeekLimit = _useState10[1];
  const _useState11 = useState(true),
    _useState12 = _slicedToArray(_useState11, 2),
    isPredefinedMonthLimit = _useState12[0],
    setIsPredefinedMonthLimit = _useState12[1];
  const _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isButtonDisabled = _useState14[0],
    setIsButtonDisabled = _useState14[1];
  const _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    period = _useState16[0],
    setPeriod = _useState16[1];
  const _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    belowGameAmount = _useState18[0],
    setBelowGameAmount = _useState18[1];
  const _useState19 = useState(),
    _useState20 = _slicedToArray(_useState19, 2),
    maxLimit = _useState20[0],
    setMaxLimit = _useState20[1];

  const calculateWarningMessage = () => {
    if (!isInRegisterFlow) {
      return false;
    }
    const minAmount = 25;
    const gameDataAmount = Number(extraData === null || extraData === void 0 ? void 0 : extraData.amount);

    if (!isNaN(dayLimit) && dayLimit !== '' && dayLimit >= minAmount && gameDataAmount > dayLimit || !isNaN(weekLimit) && weekLimit !== '' && weekLimit >= minAmount && gameDataAmount > weekLimit || !isNaN(monthLimit) && monthLimit !== '' && monthLimit >= minAmount && gameDataAmount > monthLimit) {
      return true;
    }
    return false;
  };
  useEffect(() => {
    if (!product) {
      return;
    }
    const parsedAmount = parseInt(amount, 10);
    const parsedMonthLimit = parseInt(monthLimit, 10);
    const parsedWeekLimit = parseInt(weekLimit, 10);
    const parsedDayLimit = parseInt(dayLimit, 10);

    if (parsedMonthLimit === parsedAmount) {
      setPeriod('i denna månad');
    } else if (parsedWeekLimit === parsedAmount) {
      setPeriod('i denna vecka');
    } else if (parsedDayLimit === parsedAmount) {
      setPeriod('idag');
    } else {
      setPeriod(null);
    }

    if (parsedMonthLimit < parsedAmount && parsedMonthLimit >= 25 || parsedWeekLimit < parsedAmount && parsedWeekLimit >= 25 || parsedDayLimit < parsedAmount && parsedDayLimit >= 25) {
      setBelowGameAmount(true);
    } else {
      setBelowGameAmount(false);
    }
  }, [weekLimit, dayLimit, monthLimit, amount, product, period]);
  useEffect(() => {
    (async () => {
      const _await$service$getGam = await service.getGamblingCareSpendLimitInfoAsync(),
        data = _await$service$getGam.data;
      const maxLimit = data === null || data === void 0 ? void 0 : data.spendLimit;
      if (maxLimit) {
        setMaxLimit(parseInt(maxLimit, 10));
      }
    })();
  }, []);
  const trackNavigation = (buttonName, product) => {
    svs.components.analytics.trackEvent({
      category: buttonName,
      action: 'limits_nav',
      opt_label: product || 'No product' 
    });
  };
  const handleFormIsDone = async (predefinedMonthLimit, predefinedWeekLimit, predefinedDayLimit) => {
    var _extraData$productInf;
    const isShowLimitWarning = calculateWarningMessage();
    let doContinue = true;
    if (isShowLimitWarning) {
      doContinue = await showLimitWarningDialog('Ditt spel kostar mer än din valda gräns', 'För att kunna lägga det här spelet behöver din gräns tillåta ett högre belopp. </br> Vill du ändra dina gränser, eller fortsätta ändå?', 'Fortsätt ändå', 'Ändra gränser');
    }
    setIsPredefinedMonthLimit(predefinedMonthLimit);
    setIsPredefinedWeekLimit(predefinedWeekLimit);
    setIsPredefinedDayLimit(predefinedDayLimit);
    trackNavigation('Fortsätt', (extraData === null || extraData === void 0 || (_extraData$productInf = extraData.productInfo) === null || _extraData$productInf === void 0 ? void 0 : _extraData$productInf.productDisplayName) || null);
    doContinue && setStep('confirm');
  };
  const navigateToDeposit = () => {
    var _extraData$productInf2;
    let urlString = '';
    const getSeparator = string => {
      if (string.includes('?')) {
        return '&';
      }
      return '?';
    };
    const trackLimits = () => {
      const trackingProductName = (extraData === null || extraData === void 0 ? void 0 : extraData.product) || 'No product';

      svs.components.analytics.trackEvent({
        category: 'Deposit_limit_month',
        action: isPredefinedMonthLimit ? 'predefined' : 'set',
        opt_label: trackingProductName,
        opt_value: parseInt(monthLimit, 10)
      });
      svs.components.analytics.trackEvent({
        category: 'Deposit_limit_week',
        action: isPredefinedWeekLimit ? 'predefined' : 'set',
        opt_label: trackingProductName,
        opt_value: parseInt(weekLimit, 10)
      });
      svs.components.analytics.trackEvent({
        category: 'Deposit_limit_day',
        action: isPredefinedDayLimit ? 'predefined' : 'set',
        opt_label: trackingProductName,
        opt_value: parseInt(dayLimit, 10)
      });
    };

    urlString += returnUrl ? "".concat(getSeparator(urlString), "returnUrl=").concat(returnUrl) : '';
    urlString += !isInRegisterFlow ? "".concat(getSeparator(urlString), "setLimits=1") : '';
    preDefinedLimitsSupporternEnabled && trackLimits();
    trackNavigation('Spara insättningsgränser', (extraData === null || extraData === void 0 || (_extraData$productInf2 = extraData.productInfo) === null || _extraData$productInf2 === void 0 ? void 0 : _extraData$productInf2.productDisplayName) || null);
    history.push("".concat(routes.DEPOSIT).concat(urlString)); 
  };
  const handleDoItLaterClick = async () => {
    var _extraData$productInf3;
    if (isButtonDisabled) {
      return;
    }
    setIsButtonDisabled(true);
    const betProduct = (extraData === null || extraData === void 0 || (_extraData$productInf3 = extraData.productInfo) === null || _extraData$productInf3 === void 0 ? void 0 : _extraData$productInf3.productDisplayName) || null;
    trackNavigation('Tillbaka till spelet', betProduct);
    showHandleDoItLaterDialog(betProduct, returnUrl);
    setIsButtonDisabled(false);
  };
  const pageTitleDepositLimits = suggestedLimitsABTest ? 'Välj hur mycket du vill kunna sätta in på ditt spelkonto' : 'Bestäm hur mycket du vill kunna sätta in';
  return React.createElement(Fragment, null, React.createElement(Header, null), React.createElement(DesktopContentConstrain, null, React.createElement(GridBase, {
    className: "margin-xl-top-2 margin-lg-top-2 padding-xl-top-4 padding-lg-top-4"
  }, React.createElement("div", {
    className: "margin-bottom-1"
  }, React.createElement(StepIndicatorBalls, {
    isLabelsHidden: true,
    isShowDottedLines: true,
    step: 2
  })), React.createElement(FadeInSlideWrapper, null, React.createElement(PageTitle, null, step === 'form' && pageTitleDepositLimits || 'Dina insättningsgränser'), step === 'form' && React.createElement(Fragment, null, React.createElement("div", null, suggestedLimitsABTest && React.createElement(Fragment, null, React.createElement("p", {
    className: "f-medium"
  }, "Du v\xE4ljer sj\xE4lv det som passar dig."), React.createElement("p", null, " Gr\xE4nserna anger hur mycket pengar du som mest kan s\xE4tta in, inte hur mycket du m\xE5ste spela f\xF6r.")), React.createElement(SetDepositLimitsFormDropdown, {
    costOfGame: parseInt(amount, 10),
    dayLimit: dayLimit,
    infoMessage: period && !belowGameAmount ? React.createElement(LimitCoverageInfo, {
      amount: typeof amount === 'number' ? amount.toString() : amount,
      period: period,
      product: extraData.product
    }) : null,
    isTwentyToTwentyFive: isTwentyToTwentyFive,
    isUnderTwenty: isUnderTwenty,
    monthLimit: monthLimit,
    onDone: handleFormIsDone,
    setDayLimit: setDayLimit,
    setMonthLimit: setMonthLimit,
    setWeekLimit: setWeekLimit,
    warningMessage: (belowGameAmount || maxLimit && maxLimit < parseInt(amount, 10)) && React.createElement(LimitCoverageWarning, {
      amount: typeof amount === 'number' ? amount.toString() : amount,
      hasGameAmountOverMaxLimit: maxLimit < parseInt(amount, 10),
      isTwentyToTwentyFive: isTwentyToTwentyFive,
      isUnderTwenty: isUnderTwenty,
      maxLimit: maxLimit,
      product: extraData.product
    }) || '',
    weekLimit: weekLimit
  }), React.createElement(Button, {
    block: true,
    className: "margin-bottom-2",
    disabled: isButtonDisabled,
    onClick: handleDoItLaterClick,
    transparent: true
  }, product ? 'Tillbaka till spelet' : 'Gör senare')), React.createElement("section", {
    className: "margin-bottom-2"
  }, React.createElement("h2", {
    className: "f-700 margin-bottom-1 f-medium"
  }, "Bra att veta"), React.createElement("p", null, "Det finns inga krav p\xE5 att du ska s\xE4tta in pengar. Men du m\xE5ste s\xE4tta ins\xE4ttningsgr\xE4nser innan du spelar.")), React.createElement(DepositLimitsFAQ, null)), step === 'confirm' && React.createElement(SetDepositLimitsConfirm, {
    dayLimit: dayLimit,
    handleGoBack: () => {
      var _extraData$productInf4;
      trackNavigation('Ändra insättningsgränser', (extraData === null || extraData === void 0 || (_extraData$productInf4 = extraData.productInfo) === null || _extraData$productInf4 === void 0 ? void 0 : _extraData$productInf4.productDisplayName) || null);
      setStep('form');
    },
    monthLimit: monthLimit,
    onSaved: navigateToDeposit,
    weekLimit: weekLimit
  }), React.createElement(Footer, null)))));
};
svs.playerRegistration.pages.depositLimits.SetDepositLimits = SetDepositLimits;

 })(window);